"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTotalValueBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_total_value_constants_1 = require("./bc-total-value-constants");
var helpers_1 = require("../../../common/helpers");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_tooltip_behavior_1 = require("../bc-tooltip/bc-tooltip-behavior");
var BcTotalValueBehavior = (function (_super) {
    __extends(BcTotalValueBehavior, _super);
    function BcTotalValueBehavior() {
        return _super.call(this) || this;
    }
    BcTotalValueBehavior.setUpAll = function () {
        var inputElements = Array.from(document.querySelectorAll("tr[class~='".concat(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_CONTAINER_CLASS, "']")));
        var elements = [];
        for (var _i = 0, inputElements_1 = inputElements; _i < inputElements_1.length; _i++) {
            var inputElement = inputElements_1[_i];
            var bcTotalValueBehavior = new BcTotalValueBehavior();
            bcTotalValueBehavior.setElement(inputElement);
            bcTotalValueBehavior.setUp();
            elements.push(bcTotalValueBehavior);
        }
        return elements;
    };
    BcTotalValueBehavior.prototype._setUp = function () {
        var _this = this;
        this.getElements();
        this.setLabelTooltipText();
        this.addAccessibility();
        this.addTooltipToEllipsisClass();
        bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
        this.removeFocusTooltipToEllipsisClass();
        this.setLastColumnAsDefaultVisibleResponsive();
        this.displayMaxNumColumnsMobile();
        this.hideExtraInformationColumns();
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            _this.displayMaxNumColumnsMobile();
        });
    };
    BcTotalValueBehavior.prototype.getElements = function () {
        this.totalValueInformationColumns = Array.from(this.mySelf.querySelectorAll(".".concat(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_CLASS)));
        var numExtraColumns = this.totalValueInformationColumns.length - bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_INFORMATION_COLUMNS;
        this.numberExtraColumnsAdded = numExtraColumns <= 0 ? 0 : numExtraColumns;
    };
    BcTotalValueBehavior.prototype.addAccessibility = function () {
        var element = Array.from(this.mySelf.querySelectorAll(".".concat(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE)));
        for (var _i = 0, element_1 = element; _i < element_1.length; _i++) {
            var content = element_1[_i];
            (0, helpers_1.addFocusable)(content, { tabindex: '0' });
        }
    };
    BcTotalValueBehavior.prototype.setLabelTooltipText = function () {
        var tooltipText = this.mySelf.querySelectorAll(".".concat(common_constants_1.BcCommonConstants.ICONS_CLASS, ".").concat(common_constants_1.BcCommonConstants.BC_TOOLTIP_CLASS));
        tooltipText.forEach(function (element) {
            if (tooltipText != null) {
                (0, helpers_1.addFocusable)(element, { tabindex: '0' });
                var attribute = element.getAttribute(common_constants_1.BcCommonConstants.BC_TOOLTIP_TEXT);
                element.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, attribute);
            }
        });
    };
    BcTotalValueBehavior.prototype.addTooltipToEllipsisClass = function () {
        var totalValueLabels = this.mySelf.querySelectorAll("".concat(common_constants_1.BcCommonConstants.SPAN_TAG, ".").concat(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_ELLIPSIS_CLASS));
        totalValueLabels.forEach(function (totalValueLabel) {
            if (totalValueLabel.offsetWidth < totalValueLabel.scrollWidth) {
                totalValueLabel.classList.add(common_constants_1.BcCommonConstants.BC_TOOLTIP_CLASS);
                totalValueLabel.setAttribute(common_constants_1.BcCommonConstants.BC_TOOLTIP_TEXT, totalValueLabel.innerHTML);
            }
        });
    };
    BcTotalValueBehavior.prototype.removeFocusTooltipToEllipsisClass = function () {
        var totalValueLabels = document.querySelectorAll("".concat(common_constants_1.BcCommonConstants.SPAN_TAG, ".").concat(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_ELLIPSIS_CLASS));
        totalValueLabels.forEach(function (totalValueLabel) {
            totalValueLabel.removeAttribute('tabindex');
        });
    };
    BcTotalValueBehavior.prototype.displayMaxNumColumnsMobile = function () {
        var informationPrimaryColumns = this.getTotalValueInformationPrimaryColumns();
        var startPositionColumn = this.numberExtraColumnsAdded == 0 ? 0 : this.numberExtraColumnsAdded - 1;
        var numberInformationPrimaryColumnsToHide = this.getNumberInformationPrimaryColumnsToHideMobile(informationPrimaryColumns.length);
        if (window.innerWidth > bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_BREAKPOINT_XS) {
            this.changeColumnsVisibility(informationPrimaryColumns, startPositionColumn, numberInformationPrimaryColumnsToHide, common_constants_1.BcCommonConstants.FLEX);
            return;
        }
        this.changeColumnsVisibility(informationPrimaryColumns, startPositionColumn, numberInformationPrimaryColumnsToHide, common_constants_1.BcCommonConstants.NONE);
    };
    BcTotalValueBehavior.prototype.hideExtraInformationColumns = function () {
        this.changeColumnsVisibility(this.totalValueInformationColumns, 0, this.numberExtraColumnsAdded, common_constants_1.BcCommonConstants.NONE);
    };
    BcTotalValueBehavior.prototype.setLastColumnAsDefaultVisibleResponsive = function () {
        var totalValueInformationPrimaryColumns = this.getTotalValueInformationPrimaryColumns();
        if (totalValueInformationPrimaryColumns.length === 0 && this.totalValueInformationColumns.length > 0) {
            this.totalValueInformationColumns[this.totalValueInformationColumns.length - 1].classList.add(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_PRIMARY_CLASS);
        }
    };
    BcTotalValueBehavior.prototype.changeColumnsVisibility = function (totalValueColumns, startPosition, numberOfColumns, displayStyle) {
        if (totalValueColumns.length <= startPosition || totalValueColumns.length <= numberOfColumns) {
            return;
        }
        totalValueColumns.slice(startPosition, numberOfColumns).forEach(function (column) {
            column.style.display = displayStyle;
        });
    };
    BcTotalValueBehavior.prototype.getTotalValueInformationPrimaryColumns = function () {
        return Array.from(this.mySelf.querySelectorAll(".".concat(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_PRIMARY_CLASS)));
    };
    BcTotalValueBehavior.prototype.getNumberInformationPrimaryColumnsToHideMobile = function (totalColumnsInformationPrimary) {
        var numberOfInformationPrimaryToHide = totalColumnsInformationPrimary - bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_NUMBER_COLUMNS_MOBILE;
        var complementaryPrimaryColumn = this.mySelf.querySelector(".".concat(bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_CELL_COMPLEMENTARY_PRIMARY_CLASS));
        return complementaryPrimaryColumn
            ? numberOfInformationPrimaryToHide + bc_total_value_constants_1.BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_COMPLEMENTARY_COLUMNS
            : numberOfInformationPrimaryToHide;
    };
    return BcTotalValueBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcTotalValueBehavior = BcTotalValueBehavior;
